export default __webpack_public_path__ + "static/media/coriander-icon.042f083f.svg";